/* dynamic-layout-list.tsx generated by @compiled/babel-plugin v0.38.1 */
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./dynamic-layout-list.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React, { useMemo, useState } from 'react';
import Button from '@atlaskit/button/new';
import FileIcon from '@atlaskit/icon/core/file';
import PageIcon from '@atlaskit/icon/core/page';
import PullRequestIcon from '@atlaskit/icon/core/pull-request';
import VideoIcon from '@atlaskit/icon/core/video';
import Image from '@atlaskit/image';
import Lozenge from '@atlaskit/lozenge';
import { Anchor, Box, Inline, Stack, Text } from '@atlaskit/primitives/compiled';
import { useFetchSmartLinkData } from '../../hooks/useFetchSmartLinkData';
var styles = {
  documentWrapper: "_kqswh2mm _8vu412b0 _irr3l4ek",
  invisibleLinkWrapper: "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw _154iidpf _1ltvidpf _1bsb1osq _4t3i1osq _1itkglyw _bfhk1j28 _r06hglyw _1pbykb7n",
  pageIconWrapper: "_2rko12b0 _4t3izwfg _1bsbzwfg _vchhusvi _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _1e0c1txw _1bah1h6o _4cvr1h6o _bfhki8nm",
  documentMetadataIconWrapper: "_19pk1i6y _4t3i1crf _1bsb1crf",
  listDocumentWrapper: "_1bsb1osq",
  showMoreButtonWrapper: "_1bsbcmky"
};
var MAX_VISIBLE_DOCS = 3;
var InvisibleLink = function InvisibleLink(_ref) {
  var url = _ref.url;
  return /*#__PURE__*/React.createElement(Anchor, {
    href: url,
    xcss: styles.invisibleLinkWrapper,
    "aria-label": "",
    tabIndex: -1
  });
};
var getDocumentIcon = function getDocumentIcon(itemData) {
  if (itemData.url && itemData.url.includes('docs.google.com')) {
    return /*#__PURE__*/React.createElement(FileIcon, {
      color: "var(--ds-icon-success, #6A9A23)",
      label: ""
    });
  }
  if (itemData.url && itemData.url.includes('loom.com')) {
    return /*#__PURE__*/React.createElement(VideoIcon, {
      color: "var(--ds-icon-discovery, #AF59E1)",
      label: ""
    });
  }
  if (itemData.url && (itemData.url.includes('bitbucket.org') || itemData.url.includes('github.com'))) {
    return /*#__PURE__*/React.createElement(PullRequestIcon, {
      color: "var(--ds-icon-accent-green, #22A06B)",
      label: ""
    });
  }
  return /*#__PURE__*/React.createElement(PageIcon, {
    color: "var(--ds-icon-brand, #1868DB)",
    label: ""
  });
};
var DynamicLayoutListItem = function DynamicLayoutListItem(_ref2) {
  var _itemData$generator$i, _itemData$attributedT;
  var itemData = _ref2.itemData;
  return /*#__PURE__*/React.createElement(Box, {
    xcss: styles.documentWrapper
  }, /*#__PURE__*/React.createElement(InvisibleLink, {
    url: itemData.url
  }), /*#__PURE__*/React.createElement(Inline, {
    space: "space.150",
    alignBlock: "center"
  }, /*#__PURE__*/React.createElement(Box, {
    xcss: styles.pageIconWrapper
  }, getDocumentIcon(itemData)), /*#__PURE__*/React.createElement(Stack, {
    space: "space.050"
  }, /*#__PURE__*/React.createElement(Inline, {
    space: "space.050",
    alignBlock: "center"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "large",
    maxLines: 1
  }, itemData.name), itemData['atlassian:state'] === 'MERGED' && /*#__PURE__*/React.createElement(Lozenge, {
    appearance: "success",
    isBold: true
  }, "Merged")), itemData.generator && /*#__PURE__*/React.createElement(Inline, {
    space: "space.050"
  }, /*#__PURE__*/React.createElement(Box, {
    xcss: styles.documentMetadataIconWrapper
  }, /*#__PURE__*/React.createElement(Image, {
    src: (_itemData$generator$i = itemData.generator.icon) === null || _itemData$generator$i === void 0 ? void 0 : _itemData$generator$i.url,
    alt: ""
  })), /*#__PURE__*/React.createElement(Text, {
    color: "color.text.subtle",
    size: "small",
    maxLines: 1
  }, itemData.generator.name), /*#__PURE__*/React.createElement(Text, {
    color: "color.text.subtle",
    size: "small"
  }, "\u2022"), /*#__PURE__*/React.createElement(Text, {
    color: "color.text.subtle",
    size: "small"
  }, (_itemData$attributedT = itemData.attributedTo) === null || _itemData$attributedT === void 0 ? void 0 : _itemData$attributedT.name)))));
};
export var DynamicLayoutList = function DynamicLayoutList(_ref3) {
  var component = _ref3.component;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    listExpanded = _useState2[0],
    setListExpanded = _useState2[1];
  var listChildrenUrls = useMemo(function () {
    return (component.children || []).map(function (listChild) {
      var _listChild$attributes;
      return ((_listChild$attributes = listChild.attributes) === null || _listChild$attributes === void 0 ? void 0 : _listChild$attributes.url) || '';
    }).filter(function (url) {
      return !!url;
    });
  }, [component.children]);
  var _useFetchSmartLinkDat = useFetchSmartLinkData({
      urls: listChildrenUrls
    }),
    objectResolverData = _useFetchSmartLinkDat.objectResolverData;
  var showMoreButtonVisible = objectResolverData.length > MAX_VISIBLE_DOCS;
  var numVisibleDocs = listExpanded ? objectResolverData.length : MAX_VISIBLE_DOCS;
  return objectResolverData.length ? /*#__PURE__*/React.createElement(Box, {
    xcss: styles.listDocumentWrapper
  }, /*#__PURE__*/React.createElement(Stack, {
    space: "space.200"
  }, objectResolverData.slice(0, numVisibleDocs).map(function (data, idx) {
    return /*#__PURE__*/React.createElement(DynamicLayoutListItem, {
      itemData: data,
      key: idx
    });
  }), showMoreButtonVisible && /*#__PURE__*/React.createElement(Box, {
    xcss: styles.showMoreButtonWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      return setListExpanded(!listExpanded);
    },
    spacing: "compact"
  }, listExpanded ? /*#__PURE__*/React.createElement(Text, null, "See less") : /*#__PURE__*/React.createElement(Text, null, "See more"))))) : null;
};